import React, { useCallback, useRef, useState } from 'react';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';
import _ from 'lodash';

import { Intl, ModalForm } from 'components';
import AccountDirectDialService from 'api/AccountDirectDial';
import SettingsActions from 'store/reducers/Settings';
import { handlePromise } from 'utils';
import MultipleUpload from '../Multiple';
import SingleUpload from '../Single';

const UploadModal = ( {
  entityId, title, open, values, onClose, onSubmit, toggleLoading, lField = 'singleFile',
} ) => {
  const [submitErrors, setSubmitErrors] = useState( null );
  const modalFormRef = useRef( null );

  const uploadFile = useCallback( async ( field, dataToSend ) => {
    toggleLoading( true );
    const [errors, response, responseData] = await handlePromise(
      AccountDirectDialService.saveMediaAudio( entityId, dataToSend ),
    );
    toggleLoading( false );

    if ( !response.ok ) {
      modalFormRef.current.reset();
      return setSubmitErrors( _.isObject( errors )
        ? _.join( _.map( errors, ( error, key ) => `${key}: ${error}` ), '<br/>' ) : errors );
    }
    setSubmitErrors( null );
    modalFormRef.current.change( field, {
      id: responseData.id,
      uri: responseData.uri,
      originalName: responseData.originalName,
      time: responseData.time,
    } );
  }, [entityId, toggleLoading] );

  return (
    <ModalForm
      title={title}
      showErrorsInHeader
      size="lg"
      open={open}
      bodyClassName="answering-upload-file-modal"
      onClose={onClose}
      onSubmit={onSubmit}
      initialValues={values}
      validate={( formValues ) => {
        const errors = {};
        if ( values.messageType === 'poll' && ( !formValues.introductionFile || !formValues.optionsFile || !formValues.farewellFile ) ) {
          errors.files = true;
        }
        return errors;
      }}
      body={( modalForm ) => {
        modalFormRef.current = modalForm;
        const modalState = modalForm.getState();
        return (
          <>
            {values.messageType === 'poll' && (
              <MultipleUpload
                values={modalState.values}
                submitErrors={submitErrors}
                onUpload={uploadFile}
              />
            )}
            {values.messageType === 'simple_message' && (
              <SingleUpload
                field={lField}
                submitErrors={submitErrors}
                onUpload={uploadFile}
              />
            )}
            {values.messageType === 'simple_message' && modalState.submitFailed && modalState.errors.singleFile
            && <div className="error mt-1 text-md text-center"><Intl id="oneAudioError" /></div>}
            {values.messageType === 'poll' && modalState.submitFailed && modalState.errors.files
            && <div className="error mt-1 text-md text-center"><Intl id="threeAudioError" /></div>}
          </>
        );
      }}
      footer={(
        <Button
          color="app-default"
          size="app-sm"
          className="font-weight-700"
        >
          <Intl id="save" />
        </Button>
      )}
    />
  );
};

const mapDispatchToProps = ( {
  toggleLoading: SettingsActions.toggleLoading,
} );

export default connect( null, mapDispatchToProps )( UploadModal );
